import React from 'react'
import { ASGTabBackground, SkillsChallengeCon } from '../../styles'
import { ChallengeItem, challengesArray } from './skillsHelper'
import { Img } from '../../../../Components/Image/Img'
import { ALL_STAR_IMAGES, SHOW_SKILLS_CHALLENGE_ITEMS } from '../../consts'
import { BasicAccordion } from '../../../../Components/Layout/Accordion'
import { ChallengeAccordionHeader } from './ChallengeAccordionHeader'
import { ChallengeItemSection } from './ChallengeItemSection'
import { Desc } from '../../../../Components/Typography/Text.styles'
import { colors } from '../../../../Components/consts'
import { DerbyChallengeItemSection } from './DerbyChallengeItemSection'

export const SkillsChallenge: React.FC<React.PropsWithChildren<unknown>> = () => {
  const renderChallengeItem = (challenge: ChallengeItem) => {
    return {
      headerComponent: <ChallengeAccordionHeader skillsChallenge={challenge} />,
      summaryComponent:
        challenge.slug === 'derby' ? (
          <DerbyChallengeItemSection challenge={challenge} />
        ) : (
          <ChallengeItemSection challenge={challenge} />
        ),
      colorTheme: 'darkGray' as 'darkGray',
    }
  }

  if (!SHOW_SKILLS_CHALLENGE_ITEMS) {
    return (
      <ASGTabBackground>
        <SkillsChallengeCon>
          <div className="logoCon">
            <Img src={ALL_STAR_IMAGES.skills} alt="Skills Challenge logo" />
          </div>
          <Desc textColor={colors.gray.gray20}>
            Skills Challenge events will be announced later.
          </Desc>
        </SkillsChallengeCon>
      </ASGTabBackground>
    )
  }

  return (
    <ASGTabBackground>
      <SkillsChallengeCon>
        <div className="logoCon">
          <Img src={ALL_STAR_IMAGES.skills} alt="Skills Challenge logo" />
        </div>
        <BasicAccordion
          defaultPanel={1}
          accordionItems={challengesArray.map((challenge) =>
            renderChallengeItem(challenge)
          )}
        />
      </SkillsChallengeCon>
    </ASGTabBackground>
  )
}
